<span class="ft-text">&copy; {{ year }} {{ I18n.InfoMessages.AllRightsClaim | translate }}</span>
<span class="ft-link"><a routerLink="/detailed-info">{{ build }}</a></span>
